import * as types from "../actions/types";

const mockVideoRecords = [
  {
    id: 1,
    recording_date: '2025-02-04T08:00:00',
    lesson_number: 'Р-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  },
  {
    id: 2,
    recording_date: '2025-02-04T08:45:00',
    lesson_number: '1-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '10А',
    subject_name: 'Алгебра 9'
  },
  {
    id: 3,
    recording_date: '2025-02-04T08:45:00',
    lesson_number: '1-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  },
  {
    id: 4,
    recording_date: '2025-02-04T10:30:00',
    lesson_number: '3-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  },
  {
    id: 5,
    recording_date: '2025-02-05T08:45:00',
    lesson_number: '1-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  },
  {
    id: 6,
    recording_date: '2025-02-05T10:30:00',
    lesson_number: '3-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  },
  {
    id: 7,
    recording_date: '2025-02-05T12:15:00',
    lesson_number: '4-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  },
  {
    id: 8,
    recording_date: '2025-02-06T09:30:00',
    lesson_number: '2-й урок',
    room_name: 'Кабинет №1',
    description: 'Камера 1',
    is_active: true,
    teacher_name: 'Абашкин А.Н.',
    class_name: '6Б',
    subject_name: 'Алгебра 7'
  }
];

const initialState = {
  videoRecordsList: mockVideoRecords,
  filters: {
    date_from: '',
    date_to: '',
    subject_id: '',
    teacher_id: '',
    class_id: ''
  },
  loading: false,
  // video_look state
  videoLookTeachers: [],
  videoLookCourses: [],
  videoLookGroups: [],
  videoLookList: [],
  videoLookLessonTimes: null,
  videoLookCamera: null,
  videoLookLoading: false
};

export default function video_records(state = initialState, action) {
  switch (action.type) {
    case types.SET_VIDEO_RECORDS_LIST:
      return {
        ...state,
        videoRecordsList: action.payload,
      };
    case types.SET_VIDEO_RECORDS_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case types.SET_VIDEO_RECORDS_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    // video_look cases
    case types.SET_VIDEO_LOOK_LOADING:
      return {
        ...state,
        videoLookLoading: action.payload
      };
    case types.SET_VIDEO_LOOK_TEACHERS:
      return {
        ...state,
        videoLookTeachers: action.payload
      };
    case types.SET_VIDEO_LOOK_COURSES:
      return {
        ...state,
        videoLookCourses: action.payload
      };
    case types.SET_VIDEO_LOOK_GROUPS:
      return {
        ...state,
        videoLookGroups: action.payload
      };
    case types.SET_VIDEO_LOOK_LIST:
      return {
        ...state,
        videoLookList: action.payload
      };
    case types.SET_VIDEO_LOOK_LESSON_TIMES:
      return {
        ...state,
        videoLookLessonTimes: action.payload
      };
    case types.SET_VIDEO_LOOK_CAMERA:
      return {
        ...state,
        videoLookCamera: action.payload
      };

    default:
      return state;
  }
}


